import { setDoc } from 'firebase/firestore'
import { MonthlyReport } from '../store/useStore'
import useReportDoc from './useReportDoc'

export default () => {
  const reportDoc = useReportDoc()

  return async (partial: Partial<MonthlyReport>) => {
    if (!reportDoc) {
      throw new Error(
        'Cannot update report: no effective user document reference available.'
      )
    }

    try {
      await setDoc(
        reportDoc,
        {
          ...partial,
          id: reportDoc.id,
        },
        { merge: true }
      )
    } catch (error) {
      console.error('Error updating report:', error)
      throw error
    }
  }
}
